import omit from 'lodash/omit'

import Select from 'modules/core/components/Inputs/Select'
import type { SelectProps } from 'modules/core/components/Inputs/types'
import Loading from 'modules/core/components/Loading'
import i18n from 'modules/core/lib/i18n'

import type { Country } from './regionsList'
import regionsList from './regionsList'

type Props = Omit<SelectProps, 'missingLabel' | 'selectValue'> & {
  country: Country
}

const CoreMarketRegions = (props: Props) => {
  const { country } = props
  const list = regionsList[country]

  if (!list) return <Loading />

  const options = list.sort((a, b) => a.label.localeCompare(b.label))

  return (
    <Select
      {...omit(props, ['none'])}
      none={props.none || i18n.t('common.choose')}
      options={options}
      showOriginalLabelText
    />
  )
}

export default CoreMarketRegions
